import { createReducer } from 'redux-act';
// project files
import { setLoading } from './actions';

const initialState = {
  app: true,
  fetchChallengeBasicInfo: true,
  fetchChallengeSubject: true,
};

const loadingReducer = createReducer(
  {
    [setLoading]: (state, payload) => ({ ...state, [payload.key]: payload.value }),
  },
  initialState
);

export default loadingReducer;
